import * as React from "react";

import { PageBase } from "../../components";
import { ERoutes } from "../../ERoutes";
import { useTl } from "../../hooks";
import { ETLCodes } from "../../locales/ETLCodes";
import { CompetitionReport } from "./CompetitionReport";
import { PuppyReport } from "./PuppyReport";
import { TurnOverReport } from "./TurnOverReport";
import { MemberReport } from "./MemberReport";
import { HDReport } from "./HDReport";

export interface IReportPageProps {}

export const ReportPage: React.FunctionComponent<IReportPageProps> = (props) => {
  const { t } = useTl();
  return (
    <PageBase breadCrumbs={[{ text: t(ETLCodes.Reports), route: ERoutes.report }]}>
      <PuppyReport />
      <TurnOverReport />
      <CompetitionReport />
      <MemberReport />
      <HDReport />
    </PageBase>
  );
};
